import { render, staticRenderFns } from "./module2.vue?vue&type=template&id=14f1a7d4&scoped=true"
import script from "./module2.vue?vue&type=script&lang=js"
export * from "./module2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f1a7d4",
  null
  
)

export default component.exports